"use strict";
exports.__esModule = true;
var easing_functions_1 = require("./easing-functions");
var Animation = /** @class */ (function () {
    function Animation() {
        this.easingFunction = easing_functions_1.EasingFunctions.easeInOutCubic;
        this.startTime = null;
        this.duration = 0;
        this.finished = false;
    }
    Animation.prototype.reset = function () {
        this.tag = null;
        this.update = null;
        this.startValue = null;
        this.endValue = null;
        this.startTime = null;
        this.duration = 0;
        this.finished = false;
        this.onFinished = null;
        this.animatedObject = null;
        this.animatedChild = null;
        return this;
    };
    Animation.prototype.step = function (timestamp) {
        if (this.startTime == null) {
            this.startTime = timestamp;
        }
        if (this.startValue == null) {
            this.startValue = this.endValue;
        }
        var timeSinceAnimationStart = timestamp - this.startTime;
        var animationProgressFactor = (timeSinceAnimationStart / this.duration) * Animation.globalAnimationSpeedRatio;
        var animatedFrame = this.endValue - this.startValue;
        var animatedValue = this.easingFunction(animationProgressFactor) * animatedFrame;
        var value = this.startValue + animatedValue;
        value = Math.ceil(value * 1000000) / 1000000;
        this.update(this.animatedObject, this.animatedChild, value);
        if (animationProgressFactor > 1) {
            this.update(this.animatedObject, this.animatedChild, this.endValue);
            this.finished = true;
            if (this.onFinished != null) {
                this.onFinished(this.animatedObject);
            }
        }
    };
    Animation.globalAnimationSpeedRatio = 1; //0.5;
    return Animation;
}());
exports.Animation = Animation;
//# sourceMappingURL=animation.js.map